import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REASONED JUDGEMENT MAKING EXERCISE
                                            </div>
                                            <p>Consider three past decisions that you subsequently had to
                                                alter. Using the model of reasoned
                                                judgement, identify the factors that you did not pay
                                                sufficient attention to at the time that could
                                                have helped you to come to a better decision. What are the
                                                implications for your decision
                                                making process?</p>
                                            <div className="mobile-scroll">
                                                <div className="resonedjudmentmaking">
                                                    <div className="judmentmakingbox1">
                                                        <div className="judgmentmak_ltpad1"
                                                             style={{paddingLeft: '16px !important'}}>
                                                            <textarea className="resonedtextareaheightctrl"
                                                                      name="FactorsOverlooked"
                                                                      value={this.props.pageData?.Decision1?.FactorsOverlooked}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </div>
                                                        <div className="judgmentmak_rtpad1"
                                                             style={{paddingLeft: '16px !important'}}>
                                                            <textarea className="resonedtextareaheightctrl"
                                                                      name="ImplicationsForDecisionMakingProcess"
                                                                      value={this.props.pageData?.Decision1?.ImplicationsForDecisionMakingProcess}
                                                                      onChange={this.props.handleChangePageData('Decision1')}/>
                                                        </div>
                                                    </div>
                                                    <div className="judmentmakingbox2">
                                                        <div className="judgmentmak_ltpad2"
                                                             style={{paddingLeft: '16px !important'}}>
                                                            <textarea className="resonedtextareaheightctrl"
                                                                      name="FactorsOverlooked"
                                                                      value={this.props.pageData?.Decision2?.FactorsOverlooked}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </div>
                                                        <div className="judgmentmak_rtpad2"
                                                             style={{paddingLeft: '16px !important'}}>
                                                            <textarea className="resonedtextareaheightctrl"
                                                                      name="ImplicationsForDecisionMakingProcess"
                                                                      value={this.props.pageData?.Decision2?.ImplicationsForDecisionMakingProcess}
                                                                      onChange={this.props.handleChangePageData('Decision2')}/>
                                                        </div>
                                                    </div>
                                                    <div className="judmentmakingbox3">
                                                        <div className="judgmentmak_ltpad3"
                                                             style={{paddingLeft: '16px !important'}}>
                                                            <textarea className="resonedtextareaheightctrl"
                                                                      name="FactorsOverlooked"
                                                                      value={this.props.pageData?.Decision3?.FactorsOverlooked}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </div>
                                                        <div className="judgmentmak_rtpad3"
                                                             style={{paddingLeft: '16px !important'}}>
                                                            <textarea className="resonedtextareaheightctrl"
                                                                      name="ImplicationsForDecisionMakingProcess"
                                                                      value={this.props.pageData?.Decision3?.ImplicationsForDecisionMakingProcess}
                                                                      onChange={this.props.handleChangePageData('Decision3')}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="para-first-pad">Look across your three examples
                                                for common themes in the factors you overlooked and their
                                                implications. Consider what you could do differently next
                                                time, to make your decision making
                                                more effective.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>CRITERIA MATRIX
                                            </div>
                                            <p>When faced with a situation with multiple options for action,
                                                use a criteria matrix (such as the one
                                                shown) to evaluate which potential solutions best meet your
                                                objectives.</p>
                                            <p>Follow the procedure on the next page. As a guide, we have
                                                used an example of deciding how to
                                                launch a new website.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}